/* global ZENDESK_URL */
import {
  F_ADMINISTRATION,
  F_APPRAISERS,
  F_LOANS,
  F_ORDERS,
  F_PUBLIC,
  F_FEES,
  F_FEES_MANAGEMENT,
} from '../../../session/access'

export default (showReviewSettingsMenu, pylonSupportSso = false) => ({
  items: [
    {
      name: 'Dashboard',
      url: 'dashboard',
      exact: true,
      icon: 'icon-speedometer',
      badge: {
        variant: 'info',
      },
      access: F_ADMINISTRATION,
    },
    {
      title: true,
      name: 'Navigation',
      wrapper: {
        element: '',
        attributes: {},
      },
      access: F_PUBLIC,
    },
    {
      name: 'Loan Files',
      url: 'loans',
      icon: 'icon-folder',
      badge: {
        variant: 'info',
      },
      access: F_LOANS,
    },
    {
      name: 'Orders',
      url: 'orders',
      icon: 'icon-list',
      badge: {
        variant: 'info',
      },
      access: F_ORDERS,
    },
    {
      name: 'Needs Action',
      url: 'needsAction',
      icon: 'icon-bell',
      access: F_ORDERS,
      // No permission gate: whether this appears is decided by the views an admin
      // assigned to the role, resolved in Sidebar. publicRoute stops navList
      // falling back to a `needsAction_route` permission that does not exist.
      publicRoute: true,
    },
    {
      name: 'Appraisal Panel',
      url: 'appraisers',
      icon: 'icon-people',
      badge: {
        variant: 'info',
      },
      children: [
        {
          name: 'Appraiser Management',
          url: 'appraisers',
          badge: {
            variant: 'info',
          },
        },
        {
          name: 'Exclusionary List',
          url: 'exclusionaryList',
          badge: {
            variant: 'info',
          },
        },
      ],
      access: F_APPRAISERS,
    },
    {
      name: 'Products',
      url: 'fee',
      icon: 'fa fa-clipboard',
      access: F_FEES,
    },
    {
      name: 'Fee Management',
      url: 'fee-management',
      icon: 'fa fa-table',
      access: F_FEES_MANAGEMENT,
      permission: 'fee_management_route',
    },
    {
      name: 'Branches',
      url: 'branches',
      icon: 'fa fa-building',
      badge: {
        variant: 'info',
      },
      access: F_ADMINISTRATION,
    },
    {
      name: 'Users',
      url: 'users',
      icon: 'icon-user',
      badge: {
        variant: 'info',
      },
      children: [
        {
          name: 'User Management',
          url: 'users',
          badge: {
            variant: 'info',
          },
        },
        // {
        //   name: 'User Teams',
        //   url: 'userTeams',
        //   badge: {
        //     variant: 'info',
        //   },
        // },
        {
          name: 'User Roles and Permissions',
          url: 'userRoles',
          badge: {
            variant: 'info',
          },
        },
      ],
      access: F_ADMINISTRATION,
    },
    {
      name: 'Accounting',
      url: 'accounting',
      icon: 'fa fa-money-bill',
      badge: {
        variant: 'info',
      },
      access: F_ADMINISTRATION,
    },
    {
      name: 'Settings',
      url: 'admin_settings',
      icon: 'icon-wrench',
      badge: {
        variant: 'info',
      },
      access: F_ADMINISTRATION,
    },
    showReviewSettingsMenu && {
      name: 'Review Settings',
      url: 'reviewSettings',
      icon: 'file-search',
      badge: {
        variant: 'info',
      },
      access: F_ADMINISTRATION,
      permission: 'reviewRuleSets_route',
      children: [
        {
          name: 'Rule Sets',
          url: 'reviewRuleSets',
          badge: {
            variant: 'info',
          },
          permission: 'reviewRuleSets_route',
        },
      ],
    },
    // eslint-disable-next-line no-undef
    DEPLOYMENT_ENVIRONMENT === 'production' && {
      name: 'Help Center',
      // Pylon Help Center SSO rollout: when the flag is on for this lender the
      // life-ring points at our /sso-login interstitial (platform-initiated
      // Pylon flow); when off it links straight to Zendesk as before. The
      // provider is passed in the URL — evaluated here where the flag is
      // reliably loaded — so the interstitial doesn't depend on LD timing.
      // Use an ABSOLUTE url (window.location.origin) so navLink's isExternal()
      // treats it as an external link and honors target: '_blank' — otherwise
      // an internal '/sso-login' path renders as a react-router NavLink that
      // ignores target and navigates the current tab. This keeps the new-tab
      // behavior of today's Zendesk link (and matches the appraiser side).
      url: pylonSupportSso ? `${window.location.origin}/auth/sso-login?provider=pylon` : ZENDESK_URL,
      icon: 'fas fa-life-ring',
      badge: {
        variant: 'info',
      },
      target: '_blank',
      publicRoute: true,
    },
  ],
})
